import React from 'react';

export const openAskHelp = () => {
  window.dispatchEvent(new CustomEvent('occasia:open-help'));
};

const AskHelpButton = ({ onDark = false }) => (
  <button
    type="button"
    className={`ask-help-button${onDark ? ' ask-help-button--on-dark' : ''}`}
    aria-label="Ask for help"
    title="Ask for help"
    onClick={openAskHelp}
  >
    <img src="/icons/ask-help.png" alt="" width="24" height="24" />
  </button>
);

export default AskHelpButton;
